import { render, staticRenderFns } from "./onDuty.vue?vue&type=template&id=12b592fe&scoped=true&"
import script from "./onDuty.vue?vue&type=script&lang=js&"
export * from "./onDuty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b592fe",
  null
  
)

export default component.exports